import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@material-ui/core';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Color } from '../../../../../server-types';
import CategoryTitle from '../CategoryTitle';
import { CategoryProductsList } from './CategoryProductsList';

const StyledAccordion = styled(Accordion)`
    &:before {
        height: 2px !important;
        background-color:  ${props => props.theme.palette.background.default} !important;
    }
`;

interface ChildCategoryProps {
    categoryId: string;
    categoryName: string;
    productCount: number;
    parentColor?: Color;
}

const ChildCategory: React.FC<ChildCategoryProps> = ({ categoryId, categoryName, parentColor, productCount }) => {
    const { url } = useRouteMatch();
    const history = useHistory();
    const onClick = () => history.push(`${url}/${categoryId}`);

    return (
        <StyledAccordion elevation={0} TransitionProps={{ unmountOnExit: true }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box
                    display='flex'
                    flexGrow={1}
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <CategoryTitle
                        child
                        onClick={onClick}
                        name={categoryName}
                        color={parentColor}
                        productCount={productCount}
                    />
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <CategoryProductsList categoryId={categoryId} />
            </AccordionDetails>
        </StyledAccordion>
    );
};

export default ChildCategory;